module.exports = __webpack_public_path__ + "static/media/sentinel.fd14fb3d.png";